import React, { useState, memo, useEffect } from "react";
import {
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  Button,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
  makeStyles,
  createStyles,
  CircularProgress,
  Card,
  Chip,
} from "@material-ui/core";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import CheckCircleOutlineSharpIcon from "@material-ui/icons/CheckCircleOutlineSharp";
import LocalOfferIcon from "@material-ui/icons/LocalOffer"; // Reward
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart"; // Purchase
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents"; // Redeem
import StarIcon from "@material-ui/icons/Star"; // Default
import DirectionsWalkIcon from "@material-ui/icons/DirectionsWalk";
import CollectionsIcon from "@material-ui/icons/Collections";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import RestaurantIcon from "@material-ui/icons/Restaurant";
import TableChartIcon from "@material-ui/icons/TableChart";
import AssistantOutlinedIcon from "@material-ui/icons/AssistantOutlined";
import EmojiEventsOutlinedIcon from "@material-ui/icons/EmojiEventsOutlined";
import NotInterestedOutlinedIcon from "@material-ui/icons/NotInterestedOutlined";
import CardGiftcardOutlinedIcon from "@material-ui/icons/CardGiftcardOutlined";
import OpenWithOutlinedIcon from "@material-ui/icons/OpenWithOutlined";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import AddBoxIcon from "@material-ui/icons/AddBox";

import CardCommon from "../../../../components/card/CardCommon";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import { convertDateTimeFormat } from "../../../../utils/ConvertDateTimeFormat";
import { CustomTheme } from "../../../../types/customTheme";
import { fetchAllLoyaltyEventsInfo } from "../../../../services/customerApp/customerDetails";
import { useRouteMatch } from "react-router-dom";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import _ from "lodash";
import Pagination from "../../../../components/common/Pagination";
import deliverect from "../../../../assets/images/logos/Channel/deliverect.png";
import deliveroo from "../../../../assets/images/logos/Channel/deliveroo.png";
import eatpresto from "../../../../assets/images/logos/Channel/eatpresto.png";
import justeat from "../../../../assets/images/logos/Channel/justeat.png";
import ubereats from "../../../../assets/images/logos/Channel/ubereats.png";
import presto from "../../../../assets/images/logos/Channel/presto.png";
import kiosk from "../../../../assets/images/logos/Platform/kiosk.png";
import online from "../../../../assets/images/logos/Platform/online.png";
import other from "../../../../assets/images/logos/Platform/other.png";
import phone from "../../../../assets/images/logos/Platform/phone.png";
import walkin from "../../../../assets/images/logos/Platform/walkin.png";
import { CapitalizeFirstLetter } from "../../../../utils/ReplaceIcon";

const modeImageObj: any = {
  walk_in: { id: "walk_in", icon: <DirectionsWalkIcon /> },
  collection: { id: "collection", icon: <CollectionsIcon /> },
  delivery: { id: "delivery", icon: <LocalShippingIcon /> },
  dine_in: { id: "dine_in", icon: <RestaurantIcon /> },
  future_table: { id: "future_table", icon: <TableChartIcon /> },
};

const channelImageObj: any = {
  eatpresto: {
    id: "eatpresto",
    icon: (
      <img
        src={eatpresto}
        alt="eatpresto"
        style={{ height: "24px", width: "24px" }}
      />
    ),
  },
  deliverect: {
    id: "deliverect",
    icon: (
      <img
        src={deliverect}
        alt="deliverect"
        style={{ height: "24px", width: "24px" }}
      />
    ),
  },
  justeat: {
    id: "justeat",
    icon: (
      <img
        src={justeat}
        alt="justeat"
        style={{ height: "24px", width: "24px" }}
      />
    ),
  },
  deliveroo: {
    id: "deliveroo",
    icon: (
      <img
        src={deliveroo}
        alt="deliveroo"
        style={{ height: "24px", width: "24px" }}
      />
    ),
  },
  ubereats: {
    id: "ubereats",
    icon: (
      <img
        src={ubereats}
        alt="ubereats"
        style={{ height: "24px", width: "24px" }}
      />
    ),
  },
  wix: {
    id: "ubereats",
    icon: (
      <img
        src={ubereats}
        alt="ubereats"
        style={{ height: "24px", width: "24px" }}
      />
    ),
  },
};

const platformImageObj: any = {
  "walk in": {
    id: "walk in",
    icon: (
      <img
        src={walkin}
        alt="walkin"
        style={{ height: "24px", width: "24px" }}
      />
    ),
  },
  phone: {
    id: "phone",
    icon: (
      <img src={phone} alt="phone" style={{ height: "24px", width: "24px" }} />
    ),
  },
  kiosk: {
    id: "kiosk",
    icon: (
      <img src={kiosk} alt="kiosk" style={{ height: "24px", width: "24px" }} />
    ),
  },
  online: {
    id: "online",
    icon: (
      <img
        src={online}
        alt="online"
        style={{ height: "24px", width: "24px" }}
      />
    ),
  },
  other: {
    id: "other",
    icon: (
      <img src={other} alt="other" style={{ height: "24px", width: "24px" }} />
    ),
  },
};

interface CustomerDetailsModalProps {
  openDialog: boolean;
  setOpenDialog: (open: boolean) => void;
  selectedCustomer: any;
  programId: any;
  productsObj: any;
}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    root: { flexGrow: 1 },
    tabPanel: { padding: "16px 0" },
    timeline: {
      "& .MuiTimelineItem-missingOppositeContent:before": {
        flex: "0", // ✅ remove the default flex:1
        padding: 0,
      },
    },
    card: {
      padding: 16,
      backgroundColor: theme.palette.background.paper,
      borderRadius: 12,
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },

    label: {
      fontWeight: "bold",
      minWidth: 130,
    },
    row: {
      display: "flex",
      paddingTop: 8,
    },
    stripWrapper: {
      display: "flex",
      alignItems: "flex-start",
      position: "relative",
      overflowY: "hidden",
    },
    stripIcon: {
      width: 40,
      height: 40,
      borderRadius: "50%",
      marginTop: "20px",
      marginLeft: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 0 4px rgba(0,0,0,0.2)",
      zIndex: 2,
    },
    stripLineTop: {
      position: "absolute",
      top: 0,
      left: 38.85,
      width: 2,
      height: "calc(100% - 80px)",
      backgroundColor: "#ddd",
      zIndex: 1,
    },
    stripLine: {
      position: "absolute",
      top: 60,
      left: 40,
      width: 2,
      height: "calc(100% - 35px)",
      backgroundColor: "#ddd",
      zIndex: 1,
    },
    stripContent: {
      flex: 1,
      margin: 16,
    },
  }),
);

const StatusCard = memo(({ label, value, icon, isBoolean = false }: any) => {
  const theme = useTheme<CustomTheme>();
  const color = value
    ? theme.palette.custom.green.main
    : theme.palette.custom.red.main;
  return (
    <CardCommon
      backgroundColor={"entity_background"}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px",
      }}
    >
      <div>{icon}</div>
      <div>
        <Typography
          variant="caption"
          align="right"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </Typography>
        <Typography variant="h6" align="right">
          {isBoolean ? (
            value ? (
              <CheckCircleOutlineSharpIcon style={{ color, fontSize: 28 }} />
            ) : (
              <CancelOutlinedIcon style={{ color, fontSize: 28 }} />
            )
          ) : (
            value
          )}
        </Typography>
      </div>
    </CardCommon>
  );
});

const formatText = (text: any) => {
  return text
    .toLowerCase() // min_order_value
    .replace(/_/g, " ") // min order value
    .replace(/^\w/, (c: any) => c.toUpperCase()); // Min order value
};

const TabPanel = memo(
  ({
    value,
    index,
    children,
  }: {
    value: number;
    index: number;
    children: React.ReactNode;
  }) => {
    const classes = useStyles();
    if (value !== index) return null;
    return <div className={classes.tabPanel}>{children}</div>;
  },
);

const getFullAddress = (obj: any) =>
  [
    obj?.doorNo,
    obj?.addressLine1,
    obj?.addressLine2,
    obj?.city,
    obj?.county,
    obj?.postcode,
  ]
    .filter(Boolean)
    .join(", ");

const CustomerDetailsModal: React.FC<CustomerDetailsModalProps> = ({
  openDialog,
  setOpenDialog,
  selectedCustomer,
  programId,
  productsObj,
}) => {
  const [tabValue, setTabValue] = useState(0);
  const [loyaltyEvents, setLoyaltyEvents] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [pageSize, setPageSize] = useState("25");
  const [totalResult, setTotalResult] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState("");
  const theme = useTheme<CustomTheme>();
  const classes = useStyles();
  const match: any = useRouteMatch();

  const handleGetLoyaltyEvents = async (pageSize: any, currentPage: any) => {
    try {
      // Make an API call to fetch customer data
      const res = await fetchAllLoyaltyEventsInfo(
        match.params.locationId,
        pageSize,
        currentPage,
        selectedCustomer?.customer?.id,
        programId,
      );
      setLoyaltyEvents(res.data.data);
      setTotalPages(res.data.totalPages);
      setTotalResult(res.data.totalResults);
    } catch (err) {
      // If there is an error during the API call, set an error message in the state
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
    // Set isLoading state to false to indicate that data fetching is complete
    setIsLoading(false);
  };

  const handleChangePaginationUsingSelector = (pageSize: any) => {
    setIsLoading(true);
    setPageSize(pageSize);
    handleGetLoyaltyEvents(pageSize, currentPage);
  };

  const handleChangePaginationUsingPageNumber = (currentPage: any) => {
    setIsLoading(true);
    setCurrentPage(currentPage);
    handleGetLoyaltyEvents(pageSize, currentPage);
  };

  useEffect(() => {
    if (openDialog) {
      handleGetLoyaltyEvents("25", 1);
    }
  }, [openDialog]);

  if (!selectedCustomer) return null;

  const {
    isActive,
    isBlocked,
    takeoutCount,
    deliveryCount,
    dineInCount,
    totalValue,
    cashValue,
    cardValue,
    otherValue,
    orderCount,
    contacts = [],
    addresses = [],
    customer = {},
  } = selectedCustomer;

  const getEventIconColor = (eventType: string, theme: CustomTheme) => {
    switch (eventType?.toLowerCase()) {
      case "stamp_expired":
        return { backgroundColor: theme.palette.custom.purple.main };
      case "stamp_earned":
        return { backgroundColor: theme.palette.custom.green.main }; // orange
      case "reward_eligible":
        return { backgroundColor: theme.palette.custom.yellow.main }; // blue
      case "non_eligible_order":
        return { backgroundColor: theme.palette.custom.red.main }; // green
      case "reward_redeemed":
        return { backgroundColor: theme.palette.custom.blue.main }; // green
      default:
        return { backgroundColor: theme.palette.custom.blue.main }; // purple
    }
  };

  const getEventIcon = (eventType: string, theme: CustomTheme) => {
    switch (eventType?.toLowerCase()) {
      case "stamp_expired":
        return (
          <OpenWithOutlinedIcon
            style={{
              color: "white",
              backgroundColor: theme.palette.custom.purple.main,
            }}
          />
        );
      case "stamp_earned":
        return (
          <AssistantOutlinedIcon
            style={{
              color: "white",
              backgroundColor: theme.palette.custom.green.main,
            }}
          />
        ); // orange
      case "reward_eligible":
        return (
          <EmojiEventsOutlinedIcon
            style={{
              color: "white",
              backgroundColor: theme.palette.custom.yellow.main,
            }}
          />
        ); // blue
      case "non_eligible_order":
        return (
          <NotInterestedOutlinedIcon
            style={{
              color: "white",
              backgroundColor: theme.palette.custom.red.main,
            }}
          />
        ); // green
      case "reward_redeemed":
        return (
          <CardGiftcardOutlinedIcon
            style={{
              color: "white",
              backgroundColor: theme.palette.custom.blue.main,
            }}
          />
        ); // green
      default:
        return <StarIcon style={{ backgroundColor: "#9c27b0" }} />; // purple
    }
  };

  const formatStatus = (input: any) => {
    return input
      .toLowerCase() // convert to lowercase: "stamp_earned"
      .split("_") // split into words: ["stamp", "earned"]
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each
      .join(" "); // join back: "Stamp Earned"
  };

  return (
    <DialogCommonDefault
      open={openDialog}
      setOpen={() => setOpenDialog(false)}
      aria-labelledby="customer-dialog-title"
      maxWidth={"md"}
      isNeedFixedHeight={false}
    >
      <DialogTitle>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5">Customer Details</Typography>
          <Button onClick={() => setOpenDialog(false)}>
            <CancelOutlinedIcon style={{ fontSize: 28 }} />
          </Button>
        </div>
      </DialogTitle>

      <DialogContent>
        {/* Tabs */}
        <CardCommon backgroundColor={"entity_background"}>
          <Tabs
            centered
            value={tabValue}
            onChange={(_, v) => setTabValue(v)}
            aria-label="customer-tabs"
            variant="fullWidth"
          >
            <Tab label="Basic Information" />
            <Tab label="Addresses" />
            <Tab label="Loyalty Events" />
          </Tabs>
        </CardCommon>

        <div className={classes.root}>
          {/* Basic Information */}
          <TabPanel value={tabValue} index={0}>
            <Grid container spacing={2}>
              {/* Boolean Status Cards */}
              {/* {[
                { label: "Active", value: isActive, isBoolean: true },
                { label: "Blocked", value: isBlocked, isBoolean: true },
                {
                  label: "Marketing",
                  value: customer.marketing,
                  isBoolean: true,
                },
                {
                  label: "Verified",
                  value: customer.isVerified,
                  isBoolean: true,
                },
              ].map((item) => (
                <Grid item xs={3} key={item.label}>
                  <StatusCard {...item} />
                </Grid>
              ))} */}

              {/* Numeric Stats */}
              {[
                {
                  label: "Order Count",
                  value: orderCount,
                  icon: (
                    <BookmarkBorderIcon
                      style={{
                        fontSize: 40,
                        color: theme.palette.custom.green.main,
                      }}
                    />
                  ),
                },
                {
                  label: "Takeout Count",
                  value: takeoutCount,
                  icon: (
                    <DirectionsWalkIcon
                      style={{
                        fontSize: 40,
                        color: theme.palette.custom.yellow.main,
                      }}
                    />
                  ),
                },
                {
                  label: "Delivery Count",
                  value: deliveryCount,
                  icon: (
                    <LocalShippingIcon
                      style={{
                        fontSize: 40,
                        color: theme.palette.custom.orange.main,
                      }}
                    />
                  ),
                },
                {
                  label: "Dine In Count",
                  value: dineInCount,
                  icon: (
                    <RestaurantIcon
                      style={{
                        fontSize: 40,
                        color: theme.palette.custom.purple.main,
                      }}
                    />
                  ),
                },
                {
                  label: "Total Value",
                  value: totalValue?.toFixed(2),
                  icon: (
                    <AddBoxIcon
                      style={{
                        fontSize: 40,
                        color: theme.palette.custom.green.main,
                      }}
                    />
                  ),
                },
                {
                  label: "Cash Value",
                  value: cashValue?.toFixed(2),
                  icon: (
                    <LocalAtmIcon
                      style={{
                        fontSize: 40,
                        color: theme.palette.custom.yellow.main,
                      }}
                    />
                  ),
                },
                {
                  label: "Card Value",
                  value: cardValue?.toFixed(2),
                  icon: (
                    <CreditCardIcon
                      style={{
                        fontSize: 40,
                        color: theme.palette.custom.orange.main,
                      }}
                    />
                  ),
                },
                {
                  label: "Other Value",
                  value: otherValue?.toFixed(2),
                  icon: (
                    <LoyaltyIcon
                      style={{
                        fontSize: 40,
                        color: theme.palette.custom.purple.main,
                      }}
                    />
                  ),
                },
              ].map((item) => (
                <Grid item xs={3} key={item.label}>
                  <StatusCard {...item} />
                </Grid>
              ))}

              {/* Customer Info */}
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCommon
                    backgroundColor={"entity_background"}
                    style={{ padding: "12px" }}
                  >
                    {(customer.firstName || customer.lastName) && (
                      <div>
                        <Typography
                          style={{
                            fontSize: "11px",
                            // fontWeight: "lighter",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          Name
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "17px",
                            fontWeight: "bolder",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          {`${customer.firstName} ${customer.lastName}`}
                        </Typography>
                      </div>
                    )}

                    {customer.email && (
                      <div style={{ marginTop: "14px" }}>
                        <Typography
                          style={{
                            fontSize: "11px",
                            // fontWeight: "lighter",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          Email
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "17px",
                            fontWeight: "bolder",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          {customer.email}
                        </Typography>
                      </div>
                    )}

                    {customer.shortId && (
                      <div style={{ marginTop: "14px" }}>
                        <Typography
                          style={{
                            fontSize: "11px",
                            // fontWeight: "lighter",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          Short ID
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "17px",
                            fontWeight: "bolder",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          {customer.shortId}
                        </Typography>
                      </div>
                    )}

                    {customer.email && (
                      <div style={{ marginTop: "14px" }}>
                        <Typography
                          style={{
                            fontSize: "11px",
                            // fontWeight: "lighter",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          Email
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "17px",
                            fontWeight: "bolder",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          {customer.email}
                        </Typography>
                      </div>
                    )}
                    {selectedCustomer.lastOrder && (
                      <div style={{ marginTop: "14px" }}>
                        <Typography
                          style={{
                            fontSize: "11px",
                            // fontWeight: "lighter",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          Last Order
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "17px",
                            fontWeight: "bolder",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          {convertDateTimeFormat(selectedCustomer.lastOrder)}
                        </Typography>
                      </div>
                    )}

                    {selectedCustomer.created && (
                      <div style={{ marginTop: "14px" }}>
                        <Typography
                          style={{
                            fontSize: "11px",
                            // fontWeight: "lighter",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          First Order
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "17px",
                            fontWeight: "bolder",
                            color: theme.palette.custom.orange.contrastText,
                          }}
                          align="left"
                        >
                          {convertDateTimeFormat(selectedCustomer.created)}
                        </Typography>
                      </div>
                    )}
                  </CardCommon>
                </Grid>
                <Grid item xs={6}>
                  <CardCommon
                    backgroundColor={"entity_background"}
                    style={{ padding: "12px" }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="h5">Contact Numbers</Typography>
                      </Grid>
                      {contacts.map((c: any) => (
                        <Grid item xs={12} key={c.id}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                            }}
                          >
                            <div>
                              <Typography variant="body1" align="left">
                                {c.contactNo}
                              </Typography>
                              <Typography variant="body2" align="left">
                                {convertDateTimeFormat(c.created)}
                              </Typography>
                            </div>
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </CardCommon>
                </Grid>
              </Grid>
              {/* {[
                { label: "First Name", value: customer.firstName },
                { label: "Last Name", value: customer.lastName },
                { label: "Email", value: customer.primaryEmail },
                { label: "Short ID", value: customer.shortId },
              ].map((item) => (
                <Grid item xs={6} key={item.label}>
                  <StatusCard {...item} />
                </Grid>
              ))} */}

              {/* Contacts */}
            </Grid>
          </TabPanel>

          {/* Addresses */}
          <TabPanel value={tabValue} index={1}>
            <Grid container spacing={2}>
              {addresses.length === 0 ? (
                <Grid item xs={12}>
                  <Typography
                    align="center"
                    variant="h4"
                    color="textSecondary"
                    style={{ marginTop: "10%", marginBottom: "10%" }}
                  >
                    No addresses found.
                  </Typography>
                </Grid>
              ) : (
                addresses.map((a: any) => (
                  <Grid item xs={4} key={a.id}>
                    <CardCommon
                      backgroundColor={"entity_background"}
                      style={{ padding: "12px" }}
                    >
                      <div style={{ display: "flex" }}>
                        <Typography variant="body1" align="left">
                          {a.doorNo}
                        </Typography>
                        <Typography
                          variant="body1"
                          align="left"
                          style={{ marginLeft: "10px" }}
                        >
                          {a.addressLine1}
                        </Typography>
                      </div>
                      {a.addressLine2 && (
                        <Typography variant="body1" align="left">
                          {a.addressLine2}
                        </Typography>
                      )}
                      <Typography variant="body1" align="left">
                        {a.city}
                      </Typography>
                      <Typography variant="body1" align="left">
                        {a.postcode}
                      </Typography>
                      <Typography
                        variant="body1"
                        align="left"
                        style={{ marginTop: "4px" }}
                      >
                        {a.created}
                      </Typography>
                      <Chip
                        style={{
                          backgroundColor: theme.palette.custom.blue.main, // Chip background
                          marginTop: "4px",
                        }}
                        label={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <Typography
                              variant="body2"
                              style={{ color: "white" }}
                            >
                              Delivery Count
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{ color: "white" }}
                            >
                              {a.deliveryCount}
                            </Typography>
                          </span>
                        }
                      />
                    </CardCommon>
                  </Grid>
                ))
              )}
            </Grid>
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            {!isLoading ? (
              <div>
                {loyaltyEvents ? (
                  loyaltyEvents?.map((loyaltyEvent: any, index) => (
                    <div
                      key={index}
                      style={{ position: "relative", marginBottom: 24 }}
                    >
                      {index < loyaltyEvents.length - 1 && (
                        <div className={classes.stripLine}></div>
                      )}
                      <CardCommon backgroundColor={"entity_background"}>
                        <div className={classes.stripWrapper}>
                          {/* Left icon + line */}
                          <div
                            className={classes.stripIcon}
                            style={getEventIconColor(
                              loyaltyEvent.eventType,
                              theme,
                            )}
                          >
                            {getEventIcon(loyaltyEvent.eventType, theme)}
                          </div>
                          {index !== 0 && (
                            <div className={classes.stripLineTop}></div>
                          )}
                          {/* Show connecting line except for last card */}
                          {/* {index < loyaltyEvents.length - 1 && (
                            <div className={classes.stripLine}></div>
                          )} */}

                          {/* Right content */}
                          <div className={classes.stripContent}>
                            <div>
                              <Grid container>
                                <Grid
                                  item
                                  xs={
                                    loyaltyEvent.platform !== "online" ? 8 : 6
                                  }
                                >
                                  <Typography
                                    variant="h6"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {formatStatus(loyaltyEvent.eventType)}
                                  </Typography>
                                </Grid>
                                {loyaltyEvent.platform === "online" && (
                                  <Grid
                                    item
                                    xs={2}
                                    style={{
                                      display: "flex",
                                      alignItems: "center", // vertically center
                                      justifyContent: "end", // spacing between icon & text
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      style={{ paddingTop: 4 }}
                                    >
                                      {loyaltyEvent.channel
                                        ? channelImageObj[loyaltyEvent.channel]
                                            .icon
                                        : ""}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      style={{ paddingLeft: 8 }}
                                    >
                                      {loyaltyEvent.channel
                                        ? CapitalizeFirstLetter(
                                            loyaltyEvent.channel,
                                          ) === "Eatpresto"
                                          ? "Eat Presto"
                                          : CapitalizeFirstLetter(
                                              loyaltyEvent.channel,
                                            )
                                        : ""}
                                    </Typography>
                                  </Grid>
                                )}

                                {/* PLATFORM */}
                                <Grid
                                  item
                                  xs={2}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "end",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{ paddingTop: 4 }}
                                  >
                                    {loyaltyEvent.platform
                                      ? platformImageObj[loyaltyEvent.platform]
                                          .icon
                                      : ""}
                                  </Typography>

                                  <Typography
                                    variant="body2"
                                    style={{ paddingLeft: 8 }}
                                  >
                                    {loyaltyEvent.platform
                                      ? CapitalizeFirstLetter(
                                          loyaltyEvent.platform,
                                        )
                                      : ""}
                                  </Typography>
                                </Grid>

                                {/* MODE */}
                                <Grid
                                  item
                                  xs={2}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "end",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{ paddingTop: 4 }}
                                  >
                                    {loyaltyEvent.mode
                                      ? modeImageObj[loyaltyEvent.mode].icon
                                      : ""}
                                  </Typography>

                                  <Typography
                                    variant="body2"
                                    style={{ paddingLeft: 8 }}
                                  >
                                    {loyaltyEvent.mode
                                      ? CapitalizeFirstLetter(loyaltyEvent.mode)
                                      : ""}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </div>
                            <Typography
                              variant="body1"
                              style={{ marginBottom: 8 }}
                            >
                              {convertDateTimeFormat(loyaltyEvent.eventTime)}
                            </Typography>

                            <Grid container>
                              {/* CHANNEL */}

                              {/* RIGHT SIDE */}
                              <Grid
                                item
                                xs={3}
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                }}
                              >
                                {/* Stamp Count */}

                                {/* Reward Redeemed */}
                                {loyaltyEvent.eventType === "REWARD_REDEEMED" &&
                                  loyaltyEvent.eventType !==
                                    "NON_ELIGIBLE_ORDER" && (
                                    <Typography
                                      variant="body2"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      Reward
                                    </Typography>
                                  )}

                                {/* Non Eligible Order */}
                                {loyaltyEvent.eventType ===
                                  "NON_ELIGIBLE_ORDER" && (
                                  <Typography variant="body2">
                                    £ {loyaltyEvent.spendAmount}
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>

                            {/* {loyaltyEvent.eventType === "NON_ELIGIBLE_ORDER" &&
                              loyaltyEvent.nonEligibleCode && (
                                <div style={{ display: "flex" }}>
                                  <Typography
                                    variant="body2"
                                    style={{ marginRight: 8 }}
                                  >
                                    Reason:
                                  </Typography>
                                  <Typography variant="body2">
                                    {formatText(loyaltyEvent.nonEligibleCode)}
                                  </Typography>
                                </div>
                              )} */}
                            {!loyaltyEvent?.chosenItemId &&
                              loyaltyEvent.stampCount > 0 &&
                              loyaltyEvent.eventType !==
                                "NON_ELIGIBLE_ORDER" && (
                                <Chip
                                  style={{
                                    backgroundColor:
                                      theme.palette.custom.blue.main, // Chip background
                                  }}
                                  label={
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        style={{ color: "white" }}
                                      >
                                        Current Stamp Count
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        style={{ color: "white" }}
                                      >
                                        {loyaltyEvent.stampCount}
                                      </Typography>
                                    </span>
                                  }
                                />
                              )}
                            {loyaltyEvent?.chosenItemId && (
                              <div
                                style={{
                                  display: "flex",
                                  marginTop: "4px",
                                }}
                              >
                                {loyaltyEvent.stampCount > 0 &&
                                  loyaltyEvent.eventType !==
                                    "NON_ELIGIBLE_ORDER" && (
                                    <Chip
                                      style={{
                                        backgroundColor:
                                          theme.palette.custom.blue.main, // Chip background
                                        marginRight: "12px",
                                      }}
                                      label={
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            style={{ color: "white" }}
                                          >
                                            Current Stamp Count
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            style={{ color: "white" }}
                                          >
                                            {loyaltyEvent.stampCount}
                                          </Typography>
                                        </span>
                                      }
                                    />
                                  )}
                                <Chip
                                  style={{
                                    backgroundColor:
                                      theme.palette.custom.blue.main, // Chip background
                                  }}
                                  label={
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        style={{ color: "white" }}
                                      >
                                        {loyaltyEvent?.chosenItemId
                                          ? productsObj[
                                              loyaltyEvent.chosenItemId
                                            ]?.name
                                          : ""}
                                      </Typography>
                                    </span>
                                  }
                                />

                                <Chip
                                  style={{
                                    backgroundColor:
                                      theme.palette.custom.blue.main, // Chip background
                                    marginLeft: "12px",
                                  }}
                                  label={
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <div style={{ display: "flex" }}>
                                        <Typography
                                          variant="body2"
                                          style={{ color: "white" }}
                                        >
                                          Reward Cost
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          style={{
                                            color: "white",
                                            paddingLeft: "4px",
                                          }}
                                        >
                                          {loyaltyEvent?.rewardCost}
                                        </Typography>
                                      </div>
                                    </span>
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </CardCommon>
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "10%",
                      marginBottom: "10%",
                    }}
                  >
                    <Typography variant="h5">
                      No loyalty events found
                    </Typography>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress
                  style={{ marginTop: "10%", marginBottom: "10%" }}
                  size={40}
                  color="secondary"
                />
              </div>
            )}
            {!_.isEmpty(loyaltyEvents) && (
              <Pagination
                handleChangePaginationUsingSelector={
                  handleChangePaginationUsingSelector
                }
                handleChangePaginationUsingPageNumber={
                  handleChangePaginationUsingPageNumber
                }
                totalPages={totalPages}
                currentPage={currentPage}
                pageSize={pageSize}
                isCustomer={true}
                totalResult={totalResult}
              />
            )}
          </TabPanel>
        </div>
      </DialogContent>
    </DialogCommonDefault>
  );
};

export default React.memo(CustomerDetailsModal);
